/**
 * Экспорт выбранных товаров в Excel и PDF.
 *
 * Excel — через скрытую POST-форму (классический file download).
 * PDF — через fetch с blob-ответом (apiRequest не подходит, т.к. работает с JSON).
 */

import { state } from './store.js';
import { updateActionButtons } from './actions.js';

function getCsrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || '';
}

function getSelectedProductIds() {
    const ids = [];
    document.querySelectorAll('.checkbox-select-product:checked').forEach(cb => {
        if (!ids.includes(cb.value)) ids.push(cb.value);
    });
    return ids;
}

export function exportSelectedToExcel() {
    const productIds = getSelectedProductIds();
    if (productIds.length === 0) {
        window.showToast('warning', 'Please select products for export');
        return;
    }

    // POST-форма — стандартный приём для file download
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = `/project/${state.projectId}/download/excel-selected`;
    form.style.display = 'none';

    const csrfInput = document.createElement('input');
    csrfInput.type = 'hidden';
    csrfInput.name = '_token';
    csrfInput.value = getCsrfToken();
    form.appendChild(csrfInput);

    productIds.forEach(id => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'product_ids[]';
        input.value = id;
        form.appendChild(input);
    });

    document.body.appendChild(form);

    const exportBtn = document.getElementById('export-excel-btn');
    const originalText = exportBtn?.textContent || '';
    if (exportBtn) {
        exportBtn.disabled = true;
        exportBtn.textContent = 'Generating...';
    }

    form.submit();

    setTimeout(() => {
        if (exportBtn) {
            exportBtn.disabled = false;
            exportBtn.textContent = originalText;
        }
        updateActionButtons();
    }, 2000);
    setTimeout(() => { document.body.removeChild(form); }, 100);
}

export async function exportSelectedToPdf() {
    const productIds = getSelectedProductIds();
    if (productIds.length === 0) {
        window.showToast('warning', 'Please select products for export');
        return;
    }

    const exportBtn = document.getElementById('export-pdf-btn');
    const originalText = exportBtn?.textContent || '';
    if (exportBtn) {
        exportBtn.disabled = true;
        exportBtn.textContent = 'Generating...';
    }

    const formData = new FormData();
    formData.append('_token', getCsrfToken());
    productIds.forEach(id => formData.append('product_ids[]', id));

    try {
        const response = await fetch(`/project/${state.projectId}/download/pdf-selected`, {
            method: 'POST',
            body: formData,
        });

        if (!response.ok) {
            const text = await response.text();
            console.error('[PDF Export] Server error:', text);
            throw new Error(`Server error: ${response.status}`);
        }

        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/pdf')) {
            const text = await response.text();
            console.error('[PDF Export] Unexpected response:', text.substring(0, 500));
            throw new Error('Server returned non-PDF response');
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `specification_${state.projectId}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        window.showToast('success', 'PDF exported successfully');
    } catch (e) {
        console.error('[PDF Export] Error:', e);
        window.showToast('error', 'Failed to export PDF. Check console for details.');
    } finally {
        if (exportBtn) {
            exportBtn.disabled = false;
            exportBtn.textContent = originalText;
        }
        updateActionButtons();
    }
}
